import { render, staticRenderFns } from "./layout-global-menu-row.vue?vue&type=template&id=39082b3a&scoped=true&"
import script from "./layout-global-menu-row.vue?vue&type=script&lang=js&"
export * from "./layout-global-menu-row.vue?vue&type=script&lang=js&"
import style0 from "./layout-global-menu-row.vue?vue&type=style&index=0&id=39082b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39082b3a",
  null
  
)

export default component.exports